var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m22.335 10.743.003-.004a5.3 5.3 0 0 0 .97-1.88c.192-.685.24-1.4.143-2.103-.182-1.34-.878-2.616-2.085-3.616l-.069-.054a5.65 5.65 0 0 0-4.122-1.03 5.57 5.57 0 0 0-3.586 2.027l-.002.002-1.58 1.986-1.579-1.985-.003-.003a5.48 5.48 0 0 0-3.593-2.012h-.003c-1.343-.172-2.756.133-4.043.965q-.035.023-.068.048a5.45 5.45 0 0 0-1.46 1.594 5.31 5.31 0 0 0 .417 6.06l.002.003 7.499 9.413h0c.335.422.765.763 1.256.997.49.235 1.03.356 1.577.354h-.002.004-.002c1.048 0 2.11-.449 2.827-1.35z",
  clipRule: "evenodd"
})));
export default SvgIcHeart;